<template>
  <Layout>
    <div class="ocpp-monitoring-main">

      <b-tabs content-class="tab-content-zone text-muted" nav-class="nav-tabs-custom"
              :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">
        <b-tab v-for="(tab, i) in tabs" :key="i" :active="i === 0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i :class="`mdi ${tab.icon}`" />
            </span>
            <span class="d-none d-sm-inline-block">
              <i :class="`mdi ${tab.icon} icon-padding-right`" />
            </span>
            <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
          </template>
          <component :is="tab.component" :key="i" />
        </b-tab>
      </b-tabs>

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main.vue';

import Transaction from '@/views/pages/ocpp/monitoring/transaction.vue';
import MeterValue from '@/views/pages/ocpp/monitoring/meterValue.vue';
import ConnectorStatus from '@/views/pages/ocpp/monitoring/connectorStatus.vue';
import Reservation from '@/views/pages/ocpp/monitoring/reservation.vue';
import ProfileConnector from '@/views/pages/ocpp/monitoring/profileConnector.vue';
import Diagnostics from '@/views/pages/ocpp/monitoring/diagnostics.vue';
import Firmware from '@/views/pages/ocpp/monitoring/firmware.vue';
import Log from '@/views/pages/ocpp/monitoring/log.vue';

export default {
  components: {
    Layout,
    Transaction,
    MeterValue,
    ConnectorStatus,
    Reservation,
    ProfileConnector,
    Diagnostics,
    Firmware,
    Log
  },
  data() {
    return {
      tabs: [
        { title: 'Transaction', icon: 'mdi-recycle-variant', component: 'Transaction' },
        { title: 'Meter Value', icon: 'mdi-database-import-outline', component: 'MeterValue' },
        { title: 'Connector Status', icon: 'mdi-cable-data', component: 'ConnectorStatus' },
        { title: 'Reservation', icon: 'mdi-calendar-check-outline', component: 'Reservation' },
        { title: 'Profile Connector', icon: 'mdi-download-box-outline', component: 'ProfileConnector' },
        { title: 'Diagnostics', icon: 'mdi-sticker-check-outline', component: 'Diagnostics' },
        { title: 'Firmware', icon: 'mdi-file-download-outline', component: 'Firmware' },
        { title: 'Log', icon: 'mdi-script-text-outline', component: 'Log' },
      ]
    }
  }
}
</script>
